import { render, staticRenderFns } from "./admin_logs_table.vue?vue&type=template&id=31ed8cd3&scoped=true"
import script from "./admin_logs_table.vue?vue&type=script&lang=js"
export * from "./admin_logs_table.vue?vue&type=script&lang=js"
import style0 from "./admin_logs_table.vue?vue&type=style&index=0&id=31ed8cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed8cd3",
  null
  
)

export default component.exports